import React, { useState, useEffect } from "react";
import SamplesResults from "../sample_testing/SamplesResults";

export default function JobResults({ jobId }) {
  const resultSearchParams = {
    job_id: jobId,
  };
  return (
    <div style={{ marginTop: 20 }}>
      <SamplesResults
        key={jobId}
        searchParams={resultSearchParams}
        initialSimpleSampleView={true}
        clientView={false}
      />
    </div>
  );
}
